import { useAppSelector } from '../../../store/hooks';
import { useEffect, useState } from 'react';
// Components
import { Table } from '../index';
import { AEUTEUReallocationRow } from './index';
// Services
import {
	filterFlightsOnTransferStatus,
	filterAEUFlightsOnBeltRef
} from '../../../service/filterService';
import { sortAEUAndTEUFlights } from '../../../service/sortingService';
// Types
import {
	BaggageArrivalFlightState,
	BaggageTransferFlight,
	BaggageTransferFlightState,
	TransferFlightStatusObject
} from '../../../types';

export const AEUTEUReallocationListView = ({
	baggageFlightState
}: {
	baggageFlightState: BaggageTransferFlightState | BaggageArrivalFlightState;
}) => {
	const { selectedBelt, selectedBeltRef, currentBeltRef } = useAppSelector(
		(state) => state.beltStore
	);

	const [flightStatuses, setFlightStatuses] = useState<TransferFlightStatusObject>();
	const [sortedData, setSortedData] = useState<TransferFlightStatusObject>();
	const [targetBeltAllocation, setTargetBeltAllocations] = useState<BaggageTransferFlight[]>();

	useEffect(() => {
		if (baggageFlightState) {
			if (baggageFlightState !== undefined && selectedBelt) {
				// Only show data relevant to the current belt
				const filteredOnBelt = filterAEUFlightsOnBeltRef(baggageFlightState.data, selectedBeltRef);
				// Sort data according to completed and "incoming" flights
				const flightStatusObject = filterFlightsOnTransferStatus(filteredOnBelt);
				if (currentBeltRef !== selectedBeltRef) {
					const filteredFlightOfTargetBelt = filterAEUFlightsOnBeltRef(
						baggageFlightState.data,
						currentBeltRef
					);
					setTargetBeltAllocations(filteredFlightOfTargetBelt);
				} else {
					setTargetBeltAllocations(undefined);
				}

				setFlightStatuses(flightStatusObject);
			}
		}
	}, [selectedBelt, baggageFlightState, selectedBeltRef]);

	useEffect(() => {
		if (flightStatuses) updateSortedFlights(flightStatuses);
	}, [flightStatuses]);

	const updateSortedFlights = (flightStatusObject: TransferFlightStatusObject) => {
		// sortFlights takes an array of BaggageFlight objects and sorts them according to inBlock
		const sortedFlights = sortAEUAndTEUFlights<TransferFlightStatusObject>(flightStatusObject);
		setSortedData(sortedFlights);
	};

	return (
		<>
			{sortedData && (
				<Table>
					<tbody>
						{sortedData.openFlightsCheckedIn.map((flight) => (
							<AEUTEUReallocationRow
								flight={flight}
								key={flight.flightRef}
								targetBeltAllocations={targetBeltAllocation}
							/>
						))}
						{sortedData.openFlightsNotCheckedIn.map((flight) => (
							<AEUTEUReallocationRow
								flight={flight}
								key={flight.flightRef}
								targetBeltAllocations={targetBeltAllocation}
							/>
						))}
					</tbody>
				</Table>
			)}
		</>
	);
};
